/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Grid, Stack, Typography, Card, Skeleton, LinearProgress } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
// import { avgDwelTime } from '../../../api/sentinelAPI';
// import { footfallCard } from '../../../api/sentinelAPI';
// import { getRatio } from 'api/sentinelAPI';
// import NoDataImg from '../../../assets/images/No_data-amico.svg';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
// import DatePickerStore from './Calendar';
import UpdateIcon from '@mui/icons-material/Update';
import Uniquejourney from './KPICards/Uniquejourney';
// import DonutChart from './TrendsViewCharts/DonutChart';
// import DonutChartTwo from './TrendsViewCharts/DonutChartTwo';
// import GroupIcon from '@mui/icons-material/Group';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import Diversity3Icon from '@mui/icons-material/Diversity3';
import LineChartToggle from './lineChartToggle';
// import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import Chart from 'react-apexcharts';
import RadarChart from './RadarChart';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { GetCaptureProgress, GetBayWiseOSA, GetBayWiseVM, GetSevenDaysOSA, GetAssociateScore, GetCategoryWiseAnomaly, GetAllKpi711 } from 'api';
import { GetStoreOSA, GetBayDetails, GetBaysByStoreId } from 'api';
import Tooltip from '@mui/material/Tooltip';
// import './overview.css';

function Overview({ dates }) {
  // console.log('dates', dates);
  const { storeId } = useParams();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [storeDwelTime, setStoreDwelTime] = useState(false);
  const [averageDwellTime, setAverageDwellTime] = useState(false);
  const [dweltimeData, setDweltimedata] = useState(false);
  const [footfalldata, setFootfalldata] = useState(false);
  const [ftfall, setftfall] = useState([]);
  const [osa, setOsa] = useState('');
  const [osaData, setOsaData] = useState([]);
  const [vm, setVm] = useState('');
  const [vmData, setVmData] = useState([]);
  // const [date, setSelectedDate] = useState('');
  const selectedDate = useSelector((state) => state.customization.selectedDate)
    .toISOString()
    .slice(0, 10);
  const [empCount, setEmpCount] = useState('');
  const [costcnt, setCostcnt] = useState('');
  const [ratio, setRatio] = useState('');
  const [capProgress, setCapProgress] = useState(false);
  const [avgCapProgress, setAvgCapProgress] = useState(false);
  const [capProgressValue, setCapProgressValue] = useState(false);
  const [anomaliesLoading, setAnomaliesLoading] = useState(false);
  const [sevenDaysOSA, setSevenDaysOSA] = useState('');
  const [associateScore, setAssociateScore] = useState('');
  const [associateData, setAssociateData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [kpiData, setKpiData] = useState([]);
  const [kpiLoading, setKpiLoading] = useState(true);
  console.log(ratio);

  const accentColDark = theme.palette.success.dark;
  const accentColLight = theme.palette.success.light;

  const progressChart = {
    options: {
      chart: {
        height: 180,
        type: 'radialBar',
        sparkline: {
          enabled: true
        }
      },
      colors: [accentColLight],
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            padding: 0,
            size: '30%'
            // background: '#293450'
          },
          track: {
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              blur: 4,
              opacity: 0.15
            }
          },
          dataLabels: {
            show: false,
            name: {
              offsetY: -10,
              color: '#fff',
              fontSize: '13px'
            },
            value: {
              color: '#fff',
              fontSize: '30px',
              show: false
            }
          }
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'vertical',
          gradientToColors: [accentColDark],
          stops: [0, 100]
        }
      },
      stroke: {
        // lineCap: 'round'
      }
      // labels: ['Progress']
    },
    series: [68]
  };

  // const calDate = (d) => {
  //   setSelectedDate(d.toString());
  //   return d;
  // };

  let a = localStorage.getItem('userData');
  // storeId = JSON.parse(a).stores;
  let userId = JSON.parse(a).id;

  const [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    // dispatch({ type: 'DATE', date: storeId });

    if (isMounted) {
      const extremeBody = {
        date: selectedDate.toString(),
        user_id: userId,
        city: '',
        state: '',
        zone: ''
      };

      async function getCaptureProgress(commonBody, signal) {
        setCapProgress(false);
        try {
          const data = await GetCaptureProgress(commonBody, { signal });

          if (!signal.aborted) {
            if (data) {
              // if (data.data.length > 0) {
              //   console.log('Cap Progress Data', data);
              //   const totalCapturePercentage = data.data.reduce((acc, item) => acc + item.capture_percentage, 0);
              //   const average = totalCapturePercentage / data.data.length;

              //   setAvgCapProgress(Math.floor(average));
              // } else {
              //   setAvgCapProgress('');
              // }
              const singleCapData = data.data.find((item) => item._id === storeId);
              setAvgCapProgress(singleCapData);
              setCapProgress(data.data);
            }
          }
        } catch (error) {
          if (!signal.aborted) {
            setCapProgress(false);
            console.log(error);
          }
        }
      }

      getCaptureProgress(extremeBody, signal);
      // getBrandDonutData(extremeBody, signal),
      // getBarChartData(extremeBody, signal),
      // getVMscoreBar(extremeBody, signal),
      // getFullnessForOneWeek(extremeBodyPeriod, signal),
      // getVMComplianceForOneWeek(extremeBody, signal),
      // getAnomaliesForOneWeek(extremeBodyPeriod, signal);
    }

    return () => {
      abortController.abort();
    };
  }, [selectedDate, isMounted]);

  useEffect(() => {
    // Set the component to be mounted when the effect is run
    setIsMounted(true);

    // Return a cleanup function to set the component to unmounted
    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    const commonBody = {
      start_date: selectedDate,
      storeId: '65c5e26a0b5be5dc7af327dc'
    };
    // eslint-disable-next-line
    async function getDataDwell() {
      // console.log(date);
      try {
        // const data = await avgDwelTime(commonBody);
        const data = [];
        console.log('Dwell Time', data);
        // console.log(data.length);
        if (data.length == 0) {
          setStoreDwelTime(false);
          setDweltimedata(false);
        } else if (data.length > 0) {
          const { storeDwellTime } = data;

          const storeAvgDwellTime = storeDwellTime[0].avgDwellTime;

          setStoreDwelTime(storeAvgDwellTime);

          const filteredZoneDwellTime = data.zoneDwellTime.filter((zone) => zone.zoneName !== 'Entry');
          setDweltimedata(filteredZoneDwellTime);

          const avgDwellTimeValues = filteredZoneDwellTime.map((zone) => zone.avgDwellTime);
          const total = avgDwellTimeValues.reduce((acc, val) => acc + val, 0);
          const avg = total / avgDwellTimeValues.length;
          setAverageDwellTime(avg);
        }
        return data;
      } catch (error) {
        console.log(error);
      }
    }
    console.log(commonBody);
    // eslint-disable-next-line
    async function getFootfalldata() {
      try {
        // const data = await footfallCard(commonBody);
        const data = [];
        console.log(data);
        if (data.length == 0) {
          // console.log('hello')
          setFootfalldata(false);
          setftfall(false);
        } else if (data.length > 0) {
          const { totalCustomerStore } = data[0];
          const { zones } = data[0];
          setftfall(zones);
          // console.log(zones);
          setFootfalldata(totalCustomerStore);
        }

        return data;
      } catch (error) {
        console.log(error);
      }
    }
    async function getRatioData() {
      // const body = {
      //   start_date: date,
      //   storeId: '65c5e26a0b5be5dc7af327dc'
      // };
      try {
        // const {
        //   'Customer count': customerCount,
        //   'Employee count': employeeCount,
        //   'Employee to customer ratio': ratio
        // } = await getRatio(body);
        // setEmpCount(employeeCount);
        setEmpCount(15);
        // setCostcnt(customerCount);
        setCostcnt(25);
        // setRatio(ratio);
        setRatio('3:5');
        // const u = await data.length
        // setUniquejourneys(u);
        // setJourneyData([...data]);
        // console.log(journeyData.length)
        // console.log(dta);
        // return ;
      } catch (error) {
        console.log(error);
      }
    }
    if (isMounted) {
      getFootfalldata();
      getDataDwell();
      getRatioData();
    }
    // eslint-disable-next-line
  }, [selectedDate]);

  const storedAnalysisStoreId = localStorage.getItem('analysisStoreId');
  const analysisStoreId = storedAnalysisStoreId ? JSON.parse(storedAnalysisStoreId) : null;

  useEffect(() => {
    async function getData2() {
      const body = {
        date: selectedDate,
        store_id: storeId
      };
      try {
        const response = await GetStoreOSA(body);
        const data = response.data.data;
        
        // Calculate average OSA score
        const totalOSA = data.reduce((sum, item) => sum + item.osa, 0);
        const averageOSA = totalOSA / data.length;
        
        setOsa(averageOSA.toFixed(2));
        setOsaData(data);
        return data;
      } catch (error) {
        console.log(error);
      }
    }

    getData2();
  }, [selectedDate, storeId]);

  // console.log('osadata', osa);
  // console.log('osadata2', osaData);
  // console.log('userRes', sevenDaysOSA);

  useEffect(() => {
    async function getData3() {
      const body = {
        dates: selectedDate,
        store_id: analysisStoreId
      };
      // console.log('body', body);
      try {
        const response = await GetBayWiseVM(body);
        const data = response.data;
        // console.log('vm', response);

        const lastElement = data.length - 1;
        // console.log('vm2', data[lastElement]);
        const user = data[lastElement] ? data[lastElement].avgVmScore : null;
        // console.log('users', user);
        setVm(user);
        setVmData(data[lastElement]);
        return data;
      } catch (error) {
        console.log(error);
      }
    }

    getData3();
  }, [selectedDate, analysisStoreId]);

  // console.log('vmdata', vm);
  // console.log('vmdata2', vmData);

  useEffect(() => {
    async function getData4() {
      const body = {
        date: selectedDate,
        store_id: analysisStoreId
      };
      try {
        const response = await GetAssociateScore(body);
        const data = response.data.data;
        console.log('associatess', data);
        setAssociateData(data);
        return data;
      } catch (error) {
        console.log(error);
      }
    }

    getData4();
  }, [selectedDate, analysisStoreId]);

  useEffect(() => {
    async function getData5() {
      const body = {
        dates: selectedDate,
        store_id: analysisStoreId
      };
      try {
        const response = await GetCategoryWiseAnomaly(body);
        const data = response.data;
        // console.log('associatess', data);
        setCategoryData(data);
        return data;
      } catch (error) {
        console.log(error);
      }
    }

    getData5();
  }, [selectedDate, analysisStoreId]);

  // console.log('associatedata', associateData);

  ftfall && ftfall.sort((a, b) => b.totalCustomerZone - a.totalCustomerZone);
  dweltimeData && dweltimeData.sort((a, b) => b.avgDwellTime - a.avgDwellTime);
  // console.log('avg cap progress', avgCapProgress, capProgress);

  console.log("average osa", osaData);

  // Calculate average associate percentage
  const associateAverage =
    associateData && associateData.length > 0
      ? (
          associateData.reduce((sum, item) => sum + (parseFloat(item.percentage) || 0), 0) / associateData.length
        ).toFixed(2)
      : null;

  useEffect(() => {
    async function fetchKpiData() {
      setKpiLoading(true);
      try {
        const body = {
          date: selectedDate,
          store_id: storeId
        };
        const response = await GetAllKpi711(body);
        setKpiData(response?.data || []);
      } catch (err) {
        setKpiData([]);
      } finally {
        setKpiLoading(false);
      }
    }
    fetchKpiData();
  }, [selectedDate, storeId]);

  // Calculate averages
  const avgOSA = kpiData.length ? (kpiData.reduce((sum, item) => sum + (item.osa || 0), 0) / kpiData.length).toFixed(2) : '0.00';
  const avgVM = kpiData.length ? (kpiData.reduce((sum, item) => sum + (item.vm || 0), 0) / kpiData.length).toFixed(2) : '0.00';
  const totalAnomalies = kpiData.length ? kpiData.reduce((sum, item) => sum + (item.anomaly_count || 0), 0) : 0;
  const avgProductScore = kpiData.length ? (kpiData.reduce((sum, item) => sum + (item.product_score || 0), 0) / kpiData.length).toFixed(2) : '0.00';

  // Calculate average and bay-wise capture progress from kpiData
  const avgCaptureProgress = kpiData.length ? (kpiData.reduce((sum, item) => sum + (item.capture_percentage || 0), 0) / kpiData.length).toFixed(2) : '0.00';
  const bayWiseCaptureProgress = kpiData.map(item => ({ bay_id: item.bay_id, capture_percentage: item.capture_percentage }));

  return (
    <div className="  w-full ">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction={isSmallScreen ? 'column' : 'row'} justifyContent={'space-between'}>
            <Typography variant="h3">Overview</Typography>
            {/* <div>
              <DatePickerStore SetSelectedDate={setSelectedDate} style={{ borderRadius: '15px' }} />
            </div> */}
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2} className="kpi-row" wrap="nowrap">
            {/* OSA Card */}
            <Grid item xs={12} sm={2.4} md={2.4} lg={2.4} xl={2.4}>
              <Card className="border border-gray-300" sx={{ height: '276px' }}>
                <div className="flex w-full flex-col gap-1 p-3">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <DirectionsWalkIcon className="bg-[#444444] text-white rounded-full p-2 text-6xl" />
                    <div className="w-full">
                      <p className="text-3xl">{kpiLoading ? <Skeleton width={50} /> : avgOSA}</p>
                      <p className="text-lg font-semibold">OSA Score</p>
                    </div>
                  </div>
                  <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {kpiLoading ? (
                      <Skeleton variant="rectangular" height={184} className="rounded-md" />
                    ) : kpiData.length === 0 ? (
                      <p className="text-base font-semibold text-gray-500">Currently No data available</p>
                    ) : (
                      kpiData.map((item, idx) => {
                        const percentage = item.osa || 0;
                        const barcolor = percentage >= 80 ? '#00ac69' : percentage >= 50 ? '#f4a100' : '#ff413a';
                        return (
                          <div key={idx} className="mt-2">
                            <div className="flex gap-1 items-center">
                              <div>{item.bay_id} : <span className="text-base font-semibold" style={{ color: barcolor }}>{percentage.toFixed(1)} %</span></div>
                            </div>
                            <LinearProgress
                              variant="determinate"
                              value={percentage}
                              className="rounded-lg"
                              sx={{ marginTop: '5px', backgroundColor: 'white', '& .MuiLinearProgress-bar': { backgroundColor: barcolor } }}
                            />
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </Card>
            </Grid>
            {/* VM Card */}
            <Grid item xs={12} sm={2.4} md={2.4} lg={2.4} xl={2.4}>
              <Card className="border border-gray-300" sx={{ height: '276px' }}>
                <div className="flex w-full flex-col gap-1 p-3">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <UpdateIcon className="bg-[#444444] text-white rounded-full p-2 text-6xl" />
                    <div className="w-full">
                      <p className="text-3xl">{kpiLoading ? <Skeleton width={50} /> : avgVM}</p>
                      <p className="text-lg font-semibold">VM Score</p>
                    </div>
                  </div>
                  <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {kpiLoading ? (
                      <Skeleton variant="rectangular" height={184} className="rounded-md" />
                    ) : kpiData.length === 0 ? (
                      <p className="text-base font-semibold text-gray-500">Currently No data available</p>
                    ) : (
                      kpiData.map((item, idx) => {
                        const percentage = item.vm || 0;
                        const barcolor = percentage >= 80 ? '#00ac69' : percentage >= 50 ? '#f4a100' : '#ff413a';
                        return (
                          <div key={idx} className="mt-2">
                            <div className="flex gap-1 items-center">
                              <div>{item.bay_id} : <span className="text-base font-semibold" style={{ color: barcolor }}>{percentage.toFixed(1)} %</span></div>
                            </div>
                            <LinearProgress
                              variant="determinate"
                              value={percentage}
                              className="rounded-lg"
                              sx={{ marginTop: '5px', backgroundColor: 'white', '& .MuiLinearProgress-bar': { backgroundColor: barcolor } }}
                            />
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </Card>
            </Grid>
            {/* Product Score Card */}
            <Grid item xs={12} sm={2.4} md={2.4} lg={2.4} xl={2.4}>
              <Card className="border border-gray-300" sx={{ height: '276px' }}>
                <div className="flex w-full flex-col gap-1 p-3">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <UpdateIcon className="bg-[#444444] text-white rounded-full p-2 text-6xl" />
                    <div className="w-full">
                      <p className="text-3xl">{kpiLoading ? <Skeleton width={50} /> : avgProductScore}</p>
                      <p className="text-lg font-semibold">Product Score</p>
                    </div>
                  </div>
                  <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {kpiLoading ? (
                      <Skeleton variant="rectangular" height={184} className="rounded-md" />
                    ) : kpiData.length === 0 ? (
                      <p className="text-base font-semibold text-gray-500">Currently No data available</p>
                    ) : (
                      kpiData.map((item, idx) => {
                        const score = item.product_score || 0;
                        const barcolor = score >= 80 ? '#00ac69' : score >= 50 ? '#f4a100' : '#ff413a';
                        return (
                          <div key={idx} className="mt-2">
                            <div className="flex gap-1 items-center">
                              <div>{item.bay_id} : <span className="text-base font-semibold" style={{ color: barcolor }}>{score.toFixed(1)}</span></div>
                            </div>
                            <LinearProgress
                              variant="determinate"
                              value={score}
                              className="rounded-lg"
                              sx={{ marginTop: '5px', backgroundColor: 'white', '& .MuiLinearProgress-bar': { backgroundColor: barcolor } }}
                            />
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </Card>
            </Grid>
            {/* Total Anomalies Card (moved to end) */}
            <Grid item xs={12} sm={2.4} md={2.4} lg={2.4} xl={2.4}>
              <Card className="border border-gray-300" sx={{ height: '276px' }}>
                <div className="flex w-full flex-col gap-1 p-3">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <UpdateIcon className="bg-[#444444] text-white rounded-full p-2 text-6xl" />
                    <div className="w-full">
                      <p className="text-3xl">{kpiLoading ? <Skeleton width={50} /> : totalAnomalies}</p>
                      <p className="text-lg font-semibold">Total Anomalies</p>
                    </div>
                  </div>
                  <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {kpiLoading ? (
                      <Skeleton variant="rectangular" height={184} className="rounded-md" />
                    ) : kpiData.length === 0 ? (
                      <p className="text-base font-semibold text-gray-500">Currently No data available</p>
                    ) : (
                      kpiData.map((item, idx) => {
                        const count = item.anomaly_count || 0;
                        const barcolor = count === 0 ? '#00ac69' : '#ff413a';
                        return (
                          <div key={idx} className="mt-2">
                            <div className="flex gap-1 items-center">
                              <div>{item.bay_id} : <span className="text-base font-semibold" style={{ color: barcolor }}>{count}</span></div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </Card>
            </Grid>
            {/* Associate Score Card */}
            <Grid item xs={12} sm={2.4} md={2.4} lg={2.4} xl={2.4}>
              <Card className="border border-gray-300" sx={{ height: '276px' }}>
                <div className="flex  w-full  flex-col gap-1 p-3">
                  <div className="flex items-center justify-center gap-2 w-full">
                    {/* <DirectionsWalkIcon className="bg-[#444444] text-white rounded-full p-2 text-6xl" /> */}
                    <UpdateIcon className="bg-[#444444] text-white rounded-full p-2 text-6xl" />

                    <div className="w-full">
                      <p className="text-3xl text-gray-500 ">{associateAverage !== null ? associateAverage + ' %' : 'NA'}</p>
                      <p className="text-lg font-semibold">Associate Score</p>
                    </div>
                  </div>
                  {/* <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    <p className="text-base font-semibold text-gray-500">Currently No data available</p>
                  </div> */}
                  <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {associateData.length === 0 ? (
                      <p className="text-base font-semibold text-gray-500">Currently No data available</p>
                    ) : (
                      associateData.map((item, index) => {
                        const percentage = item.percentage != undefined ? Math.round(parseFloat(item.percentage)).toFixed(1) : 0;
                        const barcolor = percentage === 0 ? '#ff413a' : '#00ac69';
                        const tooltipContent = `Bays: ${item.total_assigned_bays} | Images: ${item.total_image_count} | Captures Today: ${item.captures_today}`;
                        return (
                          <div key={index} className="mt-2">
                            <div className="flex gap-1 items-center">
                              <Tooltip title={tooltipContent} arrow placement="bottom">
                                <div>
                                  {item.user_name} :
                                  <span className="text-base font-semibold" style={{ color: barcolor }}>
                                    {' '}
                                    {percentage} %
                                  </span>
                                </div>
                              </Tooltip>
                            </div>
                            <LinearProgress
                              variant="determinate"
                              value={percentage}
                              className="rounded-lg"
                              sx={{
                                marginTop: '5px',
                                backgroundColor: 'white',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: `${barcolor}`
                                }
                              }}
                            />
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </Card>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <Card
                className="border border-gray-300 h-full"
                sx={{
                  padding: '5px'
                }}
                style={{ height: '275px' }}
              >
                <RadarChart date={selectedDate} />
              </Card>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid className="mb-10" item xs={12} lg={9} xl={9.6}>
              <Card className="border border-gray-300" sx={{ height: '550px' }}>
                <LineChartToggle dates={selectedDate} />
              </Card>
            </Grid>
            <Grid item className="mb-10" xs={12} lg={3} xl={2.4}>
              {/* <Card className="border border-gray-300" sx={{ height: '550px' }}>
                <div
                  style={{
                    padding: '10px',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                >
                  <QuestionAnswerIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                  <div className="flex flex-col items-start pt-1">
                    <h3 className="text-4xl">12</h3>
                    <p>Message Logs</p>
                  </div>
                </div>
                <Card
                  className=" rounded-lg bg-slate-700 text-white w-[95%] mx-auto"
                  sx={{
                    marginTop: '5px',
                    padding: '0.5rem'
                  }}
                >
                  <div className="flex gap-3 mb-1">
                    <AccountCircleIcon className="bg-white text-slate-700 rounded-full p-1 text-3xl" />
                    <div className="flex flex-col gap-2">
                      <div>has not interacted with a customer over 15 mins.</div>
                      <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: 'right'
                    }}
                  >
                    08:02:53 30-01-2024
                  </div>
                </Card>
                <Card
                  className=" rounded-lg bg-slate-700 text-white w-[95%] mx-auto"
                  sx={{
                    marginTop: '5px',
                    padding: '0.5rem'
                  }}
                >
                  <div className="flex gap-3 mb-1">
                    <AccountCircleIcon className="bg-white text-slate-700 rounded-full p-1 text-3xl" />
                    <div className="flex flex-col gap-2">
                      <div>
                        Heavy customer traffic detected at Phone zone. Please re-assign <span className="font-bold">Ritesh Kumar</span> to
                        Phones zone for optimal customer - employee ratio.
                      </div>
                      <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: 'right'
                    }}
                  >
                    08:02:53 30-01-2024
                  </div>
                </Card>
                <Card
                  className=" rounded-lg bg-slate-700 text-white w-[95%] mx-auto"
                  sx={{
                    marginTop: '5px',
                    padding: '0.5rem'
                  }}
                >
                  <div className="flex gap-3 mb-1 ">
                    <AccountCircleIcon className="bg-white text-slate-700 rounded-full p-1 text-3xl" />
                    <div className="flex flex-col gap-2">
                      <div>Loyal customer 3330123 detected at entry gate.</div>
                      <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: 'right'
                    }}
                  >
                    <p>08:02:53 30-01-2024</p>
                  </div>
                </Card>
              </Card> */}
              <div className=" flex flex-col gap-2 ">
                <Card
                  className="border border-gray-300 h-2/3"
                  style={{
                    padding: '5px',
                    height: 'fit-content'
                  }}
                >
                  <div className="flex items-center">
                    <div>
                      <Chart
                        options={progressChart.options}
                        series={[parseFloat(avgCaptureProgress)]}
                        type={progressChart.options.chart.type}
                        height={progressChart.options.chart.height}
                      />
                    </div>
                    <div className="flex gap-1 flex-col">
                      <div className="text-4xl font-semibold">
                        {avgCaptureProgress}%
                      </div>
                      <div className="text-sm font-semibold">Capture Progress</div>
                    </div>
                  </div>
                </Card>
                <Card
                  className="border border-gray-300 bg-[#ff413a] flex flex-col justify-center"
                  style={{
                    padding: '16px',
                    height: '350px',
                    borderRadius: '16px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.07)'
                  }}
                >
                  <p className="text-base font-semibold text-white mb-3">Bay-wise Capture Progress</p>
                  <div
                    className="flex flex-col gap-2 overflow-y-auto custom-scrollbar"
                    style={{ maxHeight: '240px', paddingRight: '4px' }}
                  >
                    {bayWiseCaptureProgress.length === 0 ? (
                      <p className="text-base text-white">No data available</p>
                    ) : (
                      bayWiseCaptureProgress.map((item, idx) => (
                        <div key={idx} className="flex gap-2 items-center bg-white/10 rounded-lg px-2 py-1">
                          <span className="w-20 font-medium text-white truncate">{item.bay_id}:</span>
                          <LinearProgress
                            variant="determinate"
                            value={item.capture_percentage}
                            className="rounded-lg flex-1"
                            sx={{ backgroundColor: 'rgba(255,255,255,0.2)', '& .MuiLinearProgress-bar': { backgroundColor: '#fff' } }}
                          />
                          <span className="ml-2 font-semibold text-white min-w-[40px] text-right">{(item.capture_percentage || 0).toFixed(1)}%</span>
                        </div>
                      ))
                    )}
                  </div>
                  <style>{`
                    .custom-scrollbar::-webkit-scrollbar {
                      width: 6px;
                    }
                    .custom-scrollbar::-webkit-scrollbar-thumb {
                      background: rgba(255,255,255,0.3);
                      border-radius: 6px;
                    }
                    .custom-scrollbar {
                      scrollbar-width: thin;
                      scrollbar-color: rgba(255,255,255,0.3) transparent;
                    }
                  `}</style>
                </Card>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default Overview;
